import React, { useEffect, useRef, useState } from 'react';
import projects from '../../data/projects';
import SectionLabel from '../ui/SectionLabel';
import ProjectModal from '../ui/Projectmodel';
import { ProjectItem } from '../../types';
import './Projects.css';

const Projects: React.FC = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const [selected, setSelected] = useState<ProjectItem | null>(null);

  useEffect(() => {
    const targets = sectionRef.current?.querySelectorAll<HTMLElement>('.reveal');
    if (!targets) return;

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    targets.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  const isLastAlone =
    projects.length % 2 === 0 && projects.filter(p => !p.featured).length % 2 !== 0;

  return (
    <section className="section projects" id="projects" ref={sectionRef}>

      <div className="projects__head reveal">
        <SectionLabel text="Case Studies" />
        <h2 className="projects__title">
          Projects That<br /><em>Define the Future</em>
        </h2>
        <p className="projects__sub">
          Real-world deployments across industries — built to solve actual business challenges.
        </p>
      </div>

      <div className="projects__grid">
        {projects.map((p, i) => (
            <div
              className={`project-card reveal${p.featured ? ' project-card--featured' : ''}${i > 0 ? ` reveal-delay-${Math.min(i, 4)}` : ''}`}
              key={p.id}
              onClick={() => setSelected(p)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && setSelected(p)}
              style={{ cursor: 'pointer' }}
            >
              <div className={`project-card__thumb ${p.bgClass}`}>
                <div className="project-card__emoji">{p.emoji}</div>
              </div>
              <div className="project-card__body">
                <div className="project-card__cats">
                  {p.categories.map((c) => (
                    <span className="project-cat" key={c.label}>{c.label}</span>
                  ))}
                </div>
                <h3 className="project-card__title">{p.title}</h3>
                <p className="project-card__desc">{p.description}</p>
              </div>
              <div className="project-card__arrow">↗</div>
            </div>
        ))}
      </div>

      {selected && (
        <ProjectModal project={selected} onClose={() => setSelected(null)} />
      )}

    </section>
  );
};

export default Projects;